import { cn } from '@/utils/cn'
import { HTMLAttributes } from 'react'
import { useReviewList } from './use-review-list'
import { ReviewListUI } from './ui/review-list'
import { ReviewListPending } from './ui/review-list-pending'
import { Separator } from '@/components/ui/separator'
export interface ReviewListProps {
  productId: string
}

export const ReviewList = ({
  className,
  productId,
  ...props
}: ReviewListProps & HTMLAttributes<HTMLDivElement>) => {
  const { data: reviews, isPending } = useReviewList(productId)

  if (isPending) {
    return <ReviewListPending />
  }
  if (!reviews || reviews.length === 0) {
    return null
  }

  return (
    <>
      <Separator className="my-5 h-1" />
      <ReviewListUI reviews={reviews} {...props} className={cn(className)} />
    </>
  )
}
